<template>
    <div class="p-1 flex flex-col items-start">
        <button class="border mb-2 py-1 px-2 " @click="mode = 0" v-if="mode != 0">返回</button>
        <div class="w-full flex flex-col items-start" v-if="mode == 0">
            <p class="text-xs text-center w-full font-bold">已收集个人信息</p>
            <div class="mb-2">
                时间跨度：
                <select v-model="date" class="border">
                    <option value="1">7天</option>
                    <option value="2">1个月</option>
                    <option value="3">3个月</option>
                </select>
            </div>
    
            <div @click="mode = 1" class="border mb-1 rounded-sm p-2 w-full">用户账号信息</div>
            <div @click="mode = 2" class="border mb-1 rounded-sm p-2 w-full">用户交易信息</div>
            <div @click="mode = 3" class="border mb-1 rounded-sm p-2 w-full">用户使用过程信息</div>
            <div @click="mode = 4" class="border mb-1 rounded-sm p-2 w-full">设备属性信息</div>
        </div>


        <div v-if="mode == 1">
            <table class=" border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data1" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        <p @click="jump(i.content)" class=" underline text-blue-500">查看详情</p>
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="mode == 2">
            <table class="border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data2" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        <p @click="jump(i.content)" class=" underline text-blue-500">查看详情</p>
                    </td>
                </tr>
            </table>
            
        </div>
        <div v-if="mode == 3">
            <table class=" border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data3" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        <p @click="jump(i.content)" class=" underline text-blue-500">查看详情</p>
                    </td>
                </tr>
            </table>
            
        </div>
        <div v-if="mode == 4">
            <table class="border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data4" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td class="border px-2 py-1.5" v-html="i.content"></td>
                </tr>
            </table>

        </div>
    </div>
</template>

<script>
import Xc from "../../js/xinchao"
export default {
    data(){
        return {
            date:"1",
            mode:0,
            data1:[
                {name:"昵称",	purpose:"获取用户昵称，完善网络身份标识",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"头像",	purpose:"获取用户头像，完善网络身份标识",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"简介",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"性别",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"生日",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"所在地",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:{code:1025}},
                {name:"背景图",	purpose:"获取社区页面个人背景图",	scene:"社区页面个人背景图展示",status:"已收集",content:{code:1025}},
                {name:"手机号",	purpose:"注册/登录小睡眠账号；实名认证",	scene:"注册/登录账号；进行实名认证/身份验证",status:"已收集",content:{code:1025}},
                {name:"第三方应用",	purpose:"绑定第三方账号进行快捷登录",	scene:"使用第三方账号快捷登录",status:"已收集",content:{code:1025}},

            ],
            data2:[
                {name:"会员购买记录",purpose:"用于展示用户会员购买记录",scene:"客服售后；会员购买信息查询",status:"已收集",content:{code:10018}},
                {name:"睡贝充值记录",purpose:"用于展示用户睡贝充值记录",scene:"客服售后；睡贝购买信息查询",status:"已收集",content:{code:10025}},
                {name:"商品购买记录",purpose:"用于展示用户商品购买记录",scene:"客服售后；商品购买信息查询",status:"已收集",content:{code:10057}},
            ],
            data3:[
                {name:"睡眠报告",purpose:"用于展示用户睡眠报告",	scene:"我的报告-睡眠报告页面展示",	status:"已收集",content:{code:10004}},
                {name:"沉浸报告",purpose:"用于展示用户沉浸报告",	scene:"我的报告-沉浸报告展示",	status:"已收集",content:{code:10092}},
                {name:"测评报告",purpose:"用于展示用户测评报告",	scene:"我的测评页面展示",	status:"已收集",content:{code:1053,activity_link:"https://www.heartide.com/common/wenjuan/#/mp"}},
                {name:"播放历史",purpose:"用于展示用户收听音频的历史记录",	scene:"播放历史页面展示",	status:"已收集",content:{code:10059}},
                {name:"我喜欢的",purpose:"用于展示用户音频偏好信息",	scene:"我喜欢的页面展示",	status:"已收集",content:{code:1027}},
                {name:"我的播单",purpose:"用于展示用户自建音频播单列表",	scene:"用户自建播单列表",	status:"已收集",content:{code:1028}},
                {name:"内容发布",purpose:"用于展示用户上传音频、发表文字的动态",	scene:"音频播放/文字发表/图片等动态",	status:"已收集",content:{code:1040}},
                {name:"个人消息",purpose:"用于展示用户接收系统推送的服务/通知、被赞/收藏/评论等动态",	scene:"用户接收系统、社区消息动态",	status:"已收集",content:{code:10058}},
                {name:"社交关系",purpose:"用于展示社区页面关注我的人及我关注的人",	scene:"社区页面个人信息展示",	status:"已收集",content:{code:10081}},
                {name:"我的好礼",purpose:"积分兑换礼品记录",	scene:"客服售后；积分兑换记录查询",	status:"已收集",content:{code:10096}},
                {name:"地址管理",purpose:"用于邮寄用户所获得的礼品",	scene:"用户礼品寄出",	status:"已收集",content:{code:10102}},
                {name:"客服反馈",purpose:"用于收集用户反馈；问题",	scene:"收集用户反馈/问题",	status:"已收集",content:{code:1053,activity_link:"https://support.qq.com/products/83038"}},
                {name:"分享应用",purpose:"用户分享小睡眠至第三方应用",	scene:"分享小睡眠APP",	status:"已收集",content:{code:10086}},

            ],
            data4:[
                {key:"imsi",name:"IMSI",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	purpose:"安全风控、广告投放",status:"已收集",content:""},
                {key:"sSimSerialNumber",name:"SIM卡",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	purpose:"安全风控、广告投放",status:"已收集",content:""},
                {key:"imei",name:"IMEI",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",status:"已收集",content:""},
                {key:"mac",name:"MAC",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",status:"已收集",content:""},
                {key:"oaid",name:"OAID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                {key:"android_id",name:"Android_ID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                {key:"idfa",name:"IDFA",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                {key:"resolution",name:"分辨率",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                {key:"brand",name:"硬件品牌",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                {key:"net_type",name:"网络类型",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                {name:"系统剪切板",	purpose:"内容粘贴",	scene:"每次用户参与文字口令活动；发布动态、评论等内容时",status:"已收集",content:"文字内容"},
                {key:"t_mobile",name:"网络运营商",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、系统错误排查、功能兼容性分析",status:"已收集",content:""},

            ],
        }
    },
    created(){
        this.getDeviceInfo()
    },
    mounted(){

    },
    methods:{
        getDeviceInfo(){
            const isIos = /iphone|ipad|mac os/.test(navigator.userAgent.toLowerCase())
            Xc.callAppRouter("devicesInfo",{},(err,res)=>{
                console.log("设备信息：",res);
                const response = isIos?JSON.parse(res):res
                if(response.status == 1){
                    const data = response.data
                    this.data4.forEach(i=>{
                        if(i.key){
                            if(data[i.key]){
                                const content = this.insertBreaks(data[i.key])
                                i.content = content
                            }else{
                                i.content = "/"
                            }
                        }
                    })
                }
            })

        },
        jump(config){
            Xc.callAppRouter("Redirect",config,()=>{})
        },
        insertBreaks(str) {
            let result = '';
            for (let i = 0; i < str.length; i += 10) {
                result += str.slice(i, i + 10) + '<br/>';
            }
            return result;
        }
    },
}
</script>

<style lang='scss' scoped>

</style>